var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.mainclass},[_c('img',{class:_vm.subclass,attrs:{"src":_vm.src,"alt":"image6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }